// Disabled time for creating reservation
export const defaultDisabledTime = [0, 1, 2, 3, 4, 5, 6, 7, 8, 21, 22, 23]

export const dateRegexFormat = /(20[2-9][0-9])-([0-1][0-9])-([0-3][0-9])/

export const daysInAWeek = ['日', '月', '火', '水', '木', '金', '土']

export const weeksInAMonths = ['第一週', '第二週', '第三週', '第四週', '第五週']
